import { styled } from "@mui/material";
import MuiToggleButton from "@mui/material/ToggleButton";

export const RoundedToggleButton = styled(MuiToggleButton)(({ theme }) => ({
  "&.MuiToggleButtonGroup-grouped": {
    borderRadius: "24px !important",
    marginLeft: "8px",
    marginRight: "8px",
    width: "32px !important",
    height: "32px !important",
    border: 0,
  },
  backgroundColor: "white",
  color: theme.palette.primary.main,
  "&.Mui-selected, &.Mui-selected:hover": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.text,
  },
}));
